import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import { Container, Header, HeaderLeft, Title, Content, BackButton } from '../../../../../common/styles';
import { MainContainer } from '../../../styles';
import { skillsApi } from '../../../../../../services/api';
import { useAlert } from '../../../../../../contexts/AlertContext';
import LoadingSpinner from '../../../../../common/LoadingSpinner';
import CompetenciesDisplay from '../common/CompetenciesDisplay';

const SkillsCompetencies = () => {
  const { matrixId, versionId, skillId } = useParams();
  const navigate = useNavigate();
  const { showAlert } = useAlert();
  const [loading, setLoading] = useState(true);
  const [skill, setSkill] = useState(null);

  useEffect(() => {
    fetchData();
  }, [skillId]);

  const fetchData = async () => {
    try {
      const data = await skillsApi.getSkillTemplate(versionId, skillId);
      setSkill(data);
    } catch (error) {
      showAlert('Failed to fetch skill competencies', 'error', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <Container>
      <Header>
        <HeaderLeft>
          <BackButton onClick={() => navigate(`/skills-matrix/templates/${matrixId}/versions/${versionId}/configure`)}>
            <FaArrowLeft /> Back to Skills Configuration
          </BackButton>
          <Title>{skill?.skill?.name} | Competencies</Title>
        </HeaderLeft>
      </Header>

      <Content>
        <MainContainer>
          <CompetenciesDisplay
            competencies={skill?.competencies || []}
            onUpdate={fetchData}
            emptyStateTitle="No Competencies Found"
            emptyStateDescription="No competency levels have been defined for this skill yet."
            onEditSubmit={async (competency, description) => {
              await skillsApi.updateCompetencyDescription(competency.id, description);
            }}
          />
        </MainContainer>
      </Content>
    </Container>
  );
};

export default SkillsCompetencies; 